import React, {PropTypes, Component} from 'react';
import s from './socialShare.scss';
import utils from '../../../utils/utils';

export default class SocialShare extends Component {
  render() {
    const {link} = this.props;
    const absoluteLink = utils.getAbsoluteLink(link);
    return (
      <ul className={s.socialWrapper}>
        <li >
          <a data-hook="facebook-link" href={`https://www.facebook.com/dialog/share?app_id=176236506151579&display=popup&href=${absoluteLink}`} target="popup">
            <svg height="13.06" width="7" viewBox="0 0 7 13.06" data-hook="facebook-icon">
              <path className={s.facebook} id="Facebook" d="M662.544,1313.76v-5.96h2.063l0.309-2.32h-2.372V1304a0.975,0.975,0,0,1,1.187-1.13H665v-2.08a17.184,17.184,0,0,0-1.849-.09,2.842,2.842,0,0,0-3.082,3.07v1.71H658v2.32h2.069v5.96h2.475Z" transform="translate(-658 -1300.69)"/>
            </svg>
          </a>
        </li>
        <li>
          <a href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(`See the latest update from Wix.com at: ${absoluteLink}`)}`} target="popup" data-hook="twitter-link">
            <svg height="10.94" width="13" viewBox="0 0 13 10.94" data-hook="twitter-icon">
              <path className={s.twitter} id="Twitter" d="M690,1304.74a5.266,5.266,0,0,1-1.532.43,2.735,2.735,0,0,0,1.173-1.53,5.065,5.065,0,0,1-1.694.67,2.643,2.643,0,0,0-1.947-.87,2.717,2.717,0,0,0-2.667,2.76,2.862,2.862,0,0,0,.069.63,7.469,7.469,0,0,1-5.5-2.88,2.82,2.82,0,0,0-.361,1.39,2.777,2.777,0,0,0,1.186,2.29,2.614,2.614,0,0,1-1.208-.34v0.03a2.746,2.746,0,0,0,2.14,2.71,2.715,2.715,0,0,1-.7.09,2.092,2.092,0,0,1-.5-0.05,2.679,2.679,0,0,0,2.492,1.92,5.24,5.24,0,0,1-3.313,1.18,4.471,4.471,0,0,1-.636-0.04,7.309,7.309,0,0,0,4.088,1.24,7.677,7.677,0,0,0,7.589-7.85c0-.12,0-0.24-0.008-0.35A5.614,5.614,0,0,0,690,1304.74Z" transform="translate(-677 -1303.44)"/>
            </svg>
          </a>
        </li>
      </ul>
    );
  }
}

SocialShare.propTypes = {
  link: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./components/partial/SocialShare/SocialShare.js